import type { SpreadReadingProfile } from "../types";

export const threeCardsReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_3_cards",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

